import RequestUtils from "utils/RequestUtils";

/**
 * 新規申込み (パブリック、非認証) API。
 * ベース URL は /v1/api/staff 配下ではなく /v1/api/public/signup/* なので
 * RequestUtils の fetchBase を直接呼び出す代わりに global fetch を使用。
 */
const PUBLIC_BASE = (
  process.env.REACT_APP_API_BASE || "https://api.no-tel.com/v1/api/staff"
).replace(/\/staff$/, "") + "/public/signup";

async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${PUBLIC_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text();
    let message = text;
    try {
      const j = JSON.parse(text);
      message = j.message || text;
    } catch {
      /* noop */
    }
    throw new Error(message || `HTTP ${res.status}`);
  }
  return res.json();
}

export type TrialSignupRequest = {
  companyName: string;
  kana: string;
  representativeName: string;
  email: string;
  phone: string;
  password: string;
  businessType: "delivery" | "visit";
  changeDateTime: string;
  pointShopFlag: boolean;
  guestCategoryShopFlag: boolean;
  castExaminationType: "orderCount" | "shiftCount" | null;
  castExaminationCount: number | null;
  referralSource: string | null;
  verifyToken: string;
  agreedTerms: boolean;
};

export default class SignupApi {
  static sendSmsCode(phone: string, recaptcha: string) {
    return postJson<{ sent: boolean }>("/sendSmsCode", { phone, recaptcha });
  }

  static verifySmsCode(phone: string, code: string) {
    return postJson<{ token: string }>("/verifySmsCode", { phone, code });
  }

  static createTrialAccount(data: TrialSignupRequest) {
    return postJson<{
      success: boolean;
      companyGroupId: number;
      companyId: number;
      trialEnd: string | null;
    }>("/trial", data);
  }
}
